import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import "datatables.net-bs4";
import { UserContext } from "../../App";
import {
  deleteCompany,
  useCompanies,
} from "../../utils/company";
import { NavItem, NavTabs } from "../layout/Nav";
import { verifyRight } from "../../utils/users";
import TrashIcon from "../icons/TrashIcon";
import SelectionActionsPopup from "../layout/SelectionActionsPopup";
import { StyledTr } from "./bookingContent";
import ActionsMenu from "../layout/ActionsMenu";
import { OutlineButtonLink } from "../layout/OutlineButton";

export default function CompanyContent() {
  const { userInfos } = useContext(UserContext);

  const { companies, loaded } = useCompanies();
  const [checked, setChecked] = useState([]);
  const datatable = useRef(null);

  useEffect(() => {
    if (datatable.current) {
      datatable.current.destroy();
      datatable.current = null;
    }

    window.setTimeout(() => {
      datatable.current = $("#datatable").DataTable({
        retrieve: true,
        order: [[1, "asc"]],
        pageLength: 25,
      });
    }, 1);
  }, [companies]);

  const datatableContent = useMemo(() => {
    return companies.map((company, index) => {
      let actions = [];

      if (verifyRight(userInfos, "company", "update"))
        actions.push({
          label: "Modifier",
          link: `/company/${company.id}`,
        });

      if (verifyRight(userInfos, "company", "delete"))
        actions.push({
          label: "Supprimer",
          onClick: async () => {
            if (
              !window.confirm(
                "Voulez-vous vraiment supprimer cette compagnie ?"
              )
            )
              return;
            await deleteCompany(userInfos, [company.id]);
            window.location.reload();
          },
        });

      return (
        <StyledTr
          className={checked.includes(company.id) ? "checked" : ""}
          key={company.id}
        >
          <td>
            <input
              type="checkbox"
              checked={checked.includes(company.id)}
              name="bulk_action"
              value={company.id}
              onChange={handleCheckbox}
            />
          </td>
          <td>{index + 1}</td>
          <td>{company.name}</td>
          <td>{company.email}</td>
          <td>{company.city}</td>
          <td>{company.revtc || ""}</td>
          <td>
            <ActionsMenu items={actions} />
          </td>
        </StyledTr>
      );
    });
  }, [checked, companies, userInfos]);

  function handleCheckbox(e) {
    const { value, checked: isChecked } = e.target;

    if (isChecked) {
      setChecked((old) => [...old, value]);
    } else {
      setChecked((old) => old.filter((id) => id !== value));
    }
  }

  const handleDeleteCompany = useCallback(async () => {
    if (checked?.length) {
      if (!window.confirm("Voulez-vous vraiment supprimer ces entreprises ?"))
        return;
      await deleteCompany(userInfos, checked);
      window.location.reload();
    }
  }, [checked, userInfos]);


  const PortletFooter = useMemo(() => {
    if (checked.length > 0) {
      let buttons = [];
      if (verifyRight(userInfos, "company", "delete"))
        buttons.push({
          label: <TrashIcon />,
          title: "Supprimer",
          onClick: handleDeleteCompany,
        });

      return (
        <SelectionActionsPopup
          selectedItemsLength={checked.length}
          resetChecked={() => setChecked([])}
          buttons={buttons}
          items={[]}
        />
      );
    }
  }, [checked.length, handleDeleteCompany, userInfos]);

  if (!loaded) {
    return (
      <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
        <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
          <div className="">
            <div className="kt-portlet__body">
              <div className="text-center">Chargement...</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="body-container">
      <div className="title-container">
        <NavTabs className="titles">
          {verifyRight(userInfos, "company", "read") && (
            <NavItem className="active">
              <Link to="/company">Entreprises</Link>
            </NavItem>
          )}
          {verifyRight(userInfos, "driver", "read") && (
            <NavItem>
              <Link to="/driver">Chauffeurs</Link>
            </NavItem>
          )}
          {verifyRight(userInfos, "vehicle", "read") && (
            <NavItem>
              <Link to="/vehicle">Véhicules</Link>
            </NavItem>
          )}
        </NavTabs>
        <div className="header-toolbar">
          {verifyRight(userInfos, "company", "create") && (
            <OutlineButtonLink to="/addCompany/">
              <i className="la la-plus"></i>
              Créer une entreprise
            </OutlineButtonLink>
          )}
        </div>
      </div>

      <div>
        <div className="">
          <div className="kt-portlet__body">
            <div style={{ overflowX: "auto" }}>
              <table
                className="table table-striped- table-bordered table-hover table-checkable"
                id="datatable"
              >
                <thead>
                  <tr>
                    <th
                      style={{ width: "5%", textAlign: "center" }}
                      data-sort="false"
                    >
                      Selection
                    </th>
                    <th style={{ width: "5%" }}>#</th>
                    <th style={{ width: "15%" }}>Nom</th>
                    <th style={{ width: "15%" }}>Email</th>
                    <th style={{ width: "15%" }}>Ville</th>
                    <th style={{ width: "15%" }}>REVTC</th>
                    <th style={{ width: "10%" }}>Action</th>
                  </tr>
                </thead>
                <tbody>{datatableContent}</tbody>
              </table>
            </div>
          </div>
          {PortletFooter}
        </div>
      </div>
    </div>
  );
}
